import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CalendarClock } from "lucide-react";
import { PageLoading, EmptyState, PageHeader, fmtDate } from "@/components/shared";
import api from "@/lib/api";

export default function WorkerDeadlines() {
  const { t } = useTranslation();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/worker/deadlines").then((r) => setItems(r.data.deadlines)); }, []);
  if (items === null) return <PageLoading />;
  return (
    <div data-testid="worker-deadlines">
      <PageHeader title={t("worker.myDeadlines")} />
      {items.length === 0 ? <EmptyState icon={CalendarClock} title={t("worker.caughtUp")} subtitle={t("worker.noDeadlines")} /> : (
        <div className="card-soft divide-y divide-slate-50">
          {items.map((d, i) => {
            const overdue = d.days_remaining != null && d.days_remaining < 0;
            return (
              <div key={d.id + i} className="flex items-center justify-between px-4 py-3.5">
                <div className="flex items-center gap-3">
                  <div className={`flex h-9 w-9 items-center justify-center rounded-lg ${overdue ? "bg-red-50 text-red-500" : "bg-slate-100 text-slate-500"}`}><CalendarClock className="h-4 w-4" /></div>
                  <div><div className="text-sm font-semibold text-navy">{d.type === "RENEWAL" ? t("worker.renewalTitle") : d.title}</div><div className="text-xs text-slate-400">{d.type === "RENEWAL" ? t("worker.renewalType") : d.type}</div></div>
                </div>
                <div className="text-right"><div className="text-sm text-navy">{fmtDate(d.due_date)}</div>{d.days_remaining != null && <div className={`text-xs ${overdue ? "text-red-500" : d.days_remaining <= 30 ? "text-amber-500" : "text-slate-400"}`}>{overdue ? t("worker.overdue") : t("worker.days", { n: d.days_remaining })}</div>}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
